import React, { useState, useEffect } from "react";
import { NFTExport } from "../../../../models/exports";
import { linkIsVideo } from "../../../../utils/utils";
// import { Link } from "gatsby";

const AddNftCard = ({
  nft,
  selectedNFTs,
  addNFT,
  removeNFT,
}: {
  nft: NFTExport;
  selectedNFTs: NFTExport[];
  addNFT: (NFT: NFTExport) => void;
  removeNFT: (NFT: NFTExport) => void;
}) => {
  const [nftSelected, setNftSelected] = useState<boolean>(false);

  useEffect(() => {
    if (selectedNFTs) {
      // let checkIfRemoved = selectedNFTs.filter(selNFT => selNFT.id === nft.id);
      // (checkIfRemoved.length === 0 && nftSelected === true) ? setNftSelected(!nftSelected) : null

      let isSelected = selectedNFTs.filter(
        (selNFT) =>
          selNFT.id === nft.id && selNFT.type.contract === nft.type.contract
      );
      setNftSelected(isSelected.length > 0);
    }
  }, [selectedNFTs]);

  const handleCardClick = (selectedNFT) => {
    setNftSelected(!nftSelected);
    if (!nftSelected) {
      addNFT(selectedNFT);
    } else {
      removeNFT(selectedNFT);
    }
  };

  return (
    <>
      {
        <div
          className="flex flex-row bg-black"
          style={{ maxHeight: "116px", borderRadius: "4px" }}
          onClick={() => handleCardClick(nft)}
        >
          <div style={{ width: "116px" }}>
            {!linkIsVideo(nft.thumbnailURL) ? (
              <img
                className="rounded-l-sm object-cover"
                style={{
                  maxHeight: "116px",
                  minWidth: "116px",
                  maxWidth: "116px",
                  alignContent: "center",
                }}
                src={nft.thumbnailURL}
              />
            ) : (
              <video
                className="rounded-l-sm object-cover"
                style={{ width: "116px", height: "116px" }}
                autoPlay={true}
                loop={true}
                muted
              >
                <source src={nft.thumbnailURL} />
              </video>
            )}
          </div>
          <div className="grid grid-cols-5 w-full">
            <div className="col-span-4">
              <div className="flex flex-col pl-16">
                <p className="selectNftHeader pt-8 pb-4 text-white body-2 break-word">
                  {nft.name?.length > 53
                    ? nft.name.slice(0, 50) + "..."
                    : nft.name
                    ? nft.name
                    : "Name Unavailable"}
                </p>
                <p className="selectNftBody text-dark-white-64 body-1 pb-8">
                  {nft.type.name}
                </p>
              </div>
            </div>

            <div className="col-span-1 pt-8 justify-self-center">
              <input
                className="bg-transparent border-2 focus:outline-none focus:ring-transparent"
                style={{
                  color: "#000",
                  borderColor: `${nftSelected ? "#FFF" : "#FFFFFFA3"}`,
                }}
                type="checkbox"
                checked={nftSelected}
                readOnly
              />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default AddNftCard;
